module.exports = __webpack_public_path__ + "static/media/Consumer_Accessibility2020.4005e648.xlsx";